import "@/style/style.scss";
import "@/style/mag-shared.scss";

import "@/web-components/MgIcon.svelte";
import "@/web-components/MgTag.svelte";
import "@/web-components/MgInlineBadge.svelte";

import { App, createApp, version as vueVersion } from "vue";

import widgets from "@/components/widgets";
import directives from "@/directives";
import { debug, lang, version } from "@/config";
import { reloadChannel } from "@/scripts/broadcast-reload";
import { fluent } from "@/i18n";
import { injectGlobalProperties } from "@/global-properties";
import globalComponents from "@/global-components";
import { mainRouter } from "@/router";
import { storeInstance } from "@/store/mag-store";
import Main from "@/Main.vue";

function hideSplash() {
    window.onerror = null;
    window.onunhandledrejection = null;

    const splash = document.getElementById("splash");
    if (splash) {
        splash.style.opacity = "0";
        splash.style.pointerEvents = "none";
        splash.addEventListener("transitionend", () => {
            splash.remove();
        });
    }
}

console.info(`Magnetar v${version}${debug ? " -- development mode" : ""}`);

if (debug) {
    console.info(`vue ${vueVersion}`);

    window.addEventListener("error", (event) => {
        console.error(event);
    });

    window.addEventListener("unhandledrejection", (event) => {
        console.error(event);
    });
}

reloadChannel.addEventListener("message", (e) => {
    if (e.data !== null) location.href = e.data;
    else location.reload();
});

// TODO: いつの日にか消したい
const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);
window.addEventListener("resize", () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});

document.documentElement.setAttribute("lang", lang || "en-US");

const app = createApp(Main);

injectGlobalProperties(app);
app.use(storeInstance);
app.use(fluent);
app.use(mainRouter);
app.use(widgets);
app.use(directives);
app.use(globalComponents);
app.use({
    install: (app: App) => {
        app.provide("app-loaded-handler", hideSplash);
    },
});

const rootEl = document.createElement("div");
rootEl.id = "magnetar_app";
document.body.appendChild(rootEl);
app.mount(rootEl);
